import { render, staticRenderFns } from "./FullScreenControl.vue?vue&type=template&id=e127ed20&scoped=true&"
import script from "./FullScreenControl.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FullScreenControl.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e127ed20",
  null
  
)

export default component.exports